import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import ReportsAPI from "@/api/reports";

export function useReportDetails(reportId) {
  const route = useRoute();
  const router = useRouter();
  const activeTab = ref("intro");
  const showExportDialog = ref(false);

  const report = ref({
    id: reportId,
    title: "",
    date: "",
    sections: [],
  });


  const fetchReport = async () => {
    const response = await ReportsAPI.getReport(reportId);

    // The report doesn't exist or belongs to someone else: show the not-found page at this URL
    if (!response?.id) {
      router.replace({ name: "not-found", params: { pathMatch: route.path.substring(1).split("/") } });
      return;
    }

    report.value = response;
    activeTab.value = report.value.sections[0]?.id ?? activeTab.value;
  };

  return {
    report,
    activeTab,
    showExportDialog,
    fetchReport,
  };
}
